var isReactNative = function isReactNative() {
  return typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
};

export default isReactNative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tus-js-client/lib.esm/browser/isReactNative.js
// module id = 484
// module chunks = 0